import { apiBaseUrl } from '../../../core/globalVariables.js';

import React, { useEffect, useState } from 'react';
import ResetMap from "../../../core/resetMap.js";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { FaPencil } from "react-icons/fa6";
import { ImCross } from "react-icons/im";
import { TiTick } from "react-icons/ti";
import { fmesh, fmeshPoints } from '../../../core/globalVariables.js';
import { FaDrawPolygon } from "react-icons/fa";
import { TbLine } from "react-icons/tb";
import { GoDotFill } from "react-icons/go";
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { v4 as uuidv4 } from 'uuid';
import * as turf from '@turf/turf';
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import axios from 'axios';
import { TbRadioactiveFilled } from "react-icons/tb";
import { TbRadioactive } from "react-icons/tb";

const LayersPanel = ({ globalRefs, globalState }) => {
    const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
    const longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
    const mapRef = globalRefs.mapRef;
    let { layers, activeLayer, setActiveLayer, setLayers } = globalState;
    const toastRef = globalRefs.toastRef;
    const selectedYearEditing = globalState.selectedYearEditing;
    const {
        multuGroupSelectedArray,
        setMultuGroupSelectedArray,
        mapMetaData,
        isRealmLeftClickedInfoVisible,
        setIsRealmLeftClickedInfoVisible,
        setActiveTab,
        setIsRighdivrawerVisible
    } = globalState;
    let drawRef = globalRefs.drawRef;
    const currentMapIdRef = globalRefs.currentMapIdRef;
    const setRecentChangeList = globalState.setRecentChangeList;
    const recentChangeList = globalState.recentChangeList;
    const landKeySelectedKey = globalState.landKeySelectedKey;
    const setAPIReportMessage = globalState.setAPIReportMessage;
    const workingLocally = globalState.workingLocally;
    const devDeployment = globalState.devDeployment;
    const setAvailableKeys = globalState.setAvailableKeys;
    const setAvailableValues = globalState.setAvailableValues;
    const mapOverview = globalState.mapOverview;
    const setMapOverview = globalState.setMapOverview;
    const setMapMetaData = globalState.setMapMetaData;
    const setIsWorkingWithinRealm = globalState.setIsWorkingWithinRealm;
    const baseMapIDRefForRefWhenUsingOriginalLayer = globalRefs.baseMapIDRefForRefWhenUsingOriginalLayer;
    const setClickedMapIDtoLoad = globalState.setClickedMapIDtoLoad;
    const activeLayerStringFromLayerIdForSummarising = globalState.activeLayerStringFromLayerIdForSummarising;
    const setActiveLayerStringFromLayerIdForSummarising = globalState.setActiveLayerStringFromLayerIdForSummarising;
    let setIsLoading = globalState.setIsLoading;

    let userIsMapOwner = globalState.userIsMapOwner;
    let setUserIsMapOwner = globalState.setUserIsMapOwner;

    const srid = 4326;
    const pendingFeatureRef = React.useRef(null);
    const [featureAdded, setFeatureAdded] = useState(null);
    const [openLayers, setOpenLayers] = useState({});
    const [editingState, setEditingState] = useState({});
    const [featureVisibility, setFeatureVisibility] = useState({}); // <-- track visibility
    const [showNewLayerInput, setShowNewLayerInput] = useState(false);
    const [newLayerName, setNewLayerName] = useState("");
    const featureListRefs = React.useRef({});
    const [layerEditing, setLayerEditing] = useState({});
    const features = longstandingGeoJSONRef?.current?.features || [];
    const [privateMaps, setPrivateMaps] = useState([]);
    const [loadingPrivateMaps, setLoadingPrivateMaps] = useState(false);
    const selectedFeatureRefs = React.useRef({});

    // Initialize editing & visibility state for all features
    useEffect(() => {
        const initialEditState = {};
        const initialVisibility = {};
        features.forEach((feature, index) => {
            initialEditState[index] = {
                isEditing: false,
                editValue: feature.feature_data_simple?.shortname || feature.skylark_id || "Unnamed"
            };
            initialVisibility[feature.skylark_id] = true;
        });
        setEditingState(initialEditState);
        setFeatureVisibility(initialVisibility);
    }, [features]);

    const groupedLayers = features.reduce((acc, feature, index) => {
        let layerName = feature?.feature_data_simple?.layer || "Base Map Layer";
        if (!acc[layerName]) acc[layerName] = [];
        acc[layerName].push({ feature, index });
        return acc;
    }, {});

    // Add empty layers (newly created)

    Object.keys(layerEditing).forEach(layerName => {
        if (!groupedLayers[layerName]) {
            groupedLayers[layerName] = [];
        }
    });

    // toggle layers

    const toggleLayer = (layerName) => {
        setOpenLayers(prev => ({
            ...prev,
            [layerName]: !prev[layerName]
        }));
    };

    // After groupedLayers is built

    const layerNames = Object.keys(groupedLayers);

    const handleToggleEdit = (index, e) => {
        e.stopPropagation();
        setEditingState(prev => ({
            ...prev,
            [index]: { ...prev[index], isEditing: true }
        }));
    };

    // EDITING A FEATURES SHORTNAME

    const handleSaveEdit = async (index, feature) => {
        const editValue = editingState[index]?.editValue;
        const newName = editValue || feature.skylark_id;
        if (newName === feature.feature_data_simple.shortname) {
            setEditingState(prev => ({ ...prev, [index]: { ...prev[index], isEditing: false } }));
            return;
        }
        feature.feature_data_simple.shortname = newName;
        const changedFeature = {
            skylark_id: feature.skylark_id,
            feature_data_simple: feature.feature_data_simple,
        };
        try {
            const token = localStorage.getItem("token");
            if (!token) throw new Error("No token in local storage");
            const params = new URLSearchParams({ srid: String(srid) });
            const url = `${apiBaseUrl}/api/maps/${currentMapIdRef.current}/features?${params.toString()}`;
            const response = await fetch(url, {
                method: "PATCH",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify([changedFeature]),
            });
            if (!response.ok) {
                toastRef.current("Failed to rename feature", "error");
                throw new Error(`API error: ${response.statusText}`);
            }
            toastRef.current("Feature renamed successfully", "success");
            setRecentChangeList([]);
            setAPIReportMessage("");
        } catch (err) {
            console.error("Error patching feature rename:", err);
        }
        setEditingState(prev => ({ ...prev, [index]: { ...prev[index], isEditing: false } }));
    };

    // CANCEL CHANGING A FEATURES SHORTNAME

    const handleCancelEdit = (index, feature) => {
        setEditingState(prev => ({
            ...prev,
            [index]: { ...prev[index], editValue: feature.feature_data_simple.shortname, isEditing: false }
        }));
    };

    // HANE THE CHANGING OF A FEATURES SHORTNAME

    const handleChange = (index, e) => {
        const value = e.target.value;
        setEditingState(prev => ({
            ...prev,
            [index]: { ...prev[index], editValue: value }
        }));
    };

    // DETERMINE WHAT GEOMETRY TYPE A FEATURE IS FOR CIONOGRAPHY

    const getGeometryIcon = (type) => {
        switch (type) {
            case "Point":
            case "MultiPoint":
                return <GoDotFill />;
            case "LineString":
            case "MultiLineString":
                return <TbLine />;
            case "Polygon":
            case "MultiPolygon":
                return <FaDrawPolygon />;
            default:
                return null;
        }
    };

    // get the colour of each feature for the iconography

    const getFeatureColor = (skylark_id) => {
        let color = null;
        fmesh.children.forEach(child => {
            if (child.name === skylark_id) {
                if (child.material?.color) {
                    color = `#${child.material.color.getHexString()}`;
                }
            }
        });
        if (!color) {
            fmeshPoints.children.forEach(child => {
                if (child.name === skylark_id) {
                    if (child.material?.color) {
                        color = `#${child.material.color.getHexString()}`;
                    }
                }
            });
        }
        return color || "#888";
    };

    useEffect(() => {
        const initialEditState = {};
        const initialVisibility = {};
        const initialLayerEditing = {};
        features.forEach((feature, index) => {
            initialEditState[index] = {
                isEditing: false,
                editValue: feature.feature_data_simple?.shortname || feature.skylark_id || "Unnamed"
            };
            initialVisibility[feature.skylark_id] = true;
            const layerName = feature?.feature_data_simple?.layer || "Base Map Layer";
            if (!initialLayerEditing[layerName]) {
                initialLayerEditing[layerName] = {
                    isEditing: false,
                    editValue: layerName
                };
            }
        });
        setEditingState(initialEditState);
        setFeatureVisibility(initialVisibility);
        setLayerEditing(initialLayerEditing);
    }, [features]);

    const handleLayerEditToggle = (layerName, e) => {
        e.stopPropagation();
        setLayerEditing(prev => ({
            ...prev,
            [layerName]: {
                ...prev[layerName],
                isEditing: true
            }
        }));
    };

    const handleLayerNameChange = (layerName, value) => {
        setLayerEditing(prev => ({
            ...prev,
            [layerName]: {
                ...prev[layerName],
                editValue: value
            }
        }));
    };

    const handleLayerEditSave = async (oldLayerName) => {
        const newLayerName = layerEditing[oldLayerName].editValue;
        const wasOpen = openLayers[oldLayerName] || false;
        if (!newLayerName || newLayerName === oldLayerName) {
            setLayerEditing(prev => ({ ...prev, [oldLayerName]: { ...prev[oldLayerName], isEditing: false } }));
            return;
        }
        const updatedFeatures = [];
        features.forEach(feature => {
            const currentLayer = feature?.feature_data_simple?.layer;
            if (currentLayer === oldLayerName) {
                feature.feature_data_simple.layer = newLayerName;
                updatedFeatures.push({
                    skylark_id: feature.skylark_id,
                    feature_data_simple: feature.feature_data_simple
                });
            }
        });
        try {
            const token = localStorage.getItem("token");
            if (!token) throw new Error("No token in local storage");
            const url = `${apiBaseUrl}/api/maps/${currentMapIdRef.current}/features?srid=${srid}`;
            const response = await fetch(url, {
                method: "PATCH",
                headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
                body: JSON.stringify(updatedFeatures),
            });
            if (!response.ok) {
                toastRef.current("Failed to rename layer on server", "error");
                throw new Error(`API error: ${response.statusText}`);
            }
            toastRef.current("Layer renamed successfully", "success");
            setRecentChangeList([]);
            setAPIReportMessage("");
        } catch (err) {
            console.error("Error patching renamed layer features:", err);
        }
        setLayerEditing(prev => {
            const updated = { ...prev };
            delete updated[oldLayerName];
            updated[newLayerName] = { isEditing: false, editValue: newLayerName };
            return updated;
        });
        setOpenLayers(prev => {
            const updated = { ...prev };
            delete updated[oldLayerName];
            updated[newLayerName] = wasOpen;
            return updated;
        });
        setEditingState(prev => ({ ...prev }));
    };

    const handleLayerEditCancel = (layerName) => {
        setLayerEditing(prev => ({
            ...prev,
            [layerName]: {
                isEditing: false,
                editValue: layerName
            }
        }));
    };

    const [showAddLayerModel, setShowAddLayerModel] = useState("");

    const handleAddLayerClick = () => {
        setShowAddLayerModel(prev => !prev);
    };

    const handleAddBlankLayerClick = () => {
        setShowNewLayerInput(true)
        setShowAddLayerModel(false)
    }

    // confirm newly added & named blank layer

    const handleConfirmNewLayer = () => {
        if (!newLayerName.trim()) return;
        if (!layerEditing[newLayerName]) {
            setLayerEditing(prev => ({
                ...prev,
                [newLayerName]: { isEditing: false, editValue: newLayerName }
            }));
            setOpenLayers(prev => ({ ...prev, [newLayerName]: false }));
        }
        setNewLayerName("");
        setShowNewLayerInput(false);
    };

    const handleCancelNewLayer = () => {
        setNewLayerName("");
        setShowNewLayerInput(false);
    }

    // show/hide the layers features on the map

    const toggleLayerVisibility = (layerFeatures) => {
        const newVisibility = { ...featureVisibility };
        const allVisible = layerFeatures.every(({ feature }) =>
            newVisibility[feature.skylark_id]
        );
        const newState = !allVisible;
        layerFeatures.forEach(({ feature }) => {
            newVisibility[feature.skylark_id] = newState;
            fmesh.children.forEach(child => {
                if (child.name === feature.skylark_id) child.visible = newState;
            });
            fmeshPoints.children.forEach(child => {
                if (child.name === feature.skylark_id) child.visible = newState;
            });
        });
        setFeatureVisibility(newVisibility);
        polygonCustomLayerRef.current.map_repaint();
    };

    const isLayerFullyVisible = (layerFeatures) => {
        return layerFeatures.every(({ feature }) =>
            featureVisibility[feature.skylark_id]
        );
    };

    // delete layer and all its features from the API
    const handleDeleteLayer = async (layerName) => {
        if (!window.confirm(`Are you sure you want to delete layer "${layerName}"? This cannot be undone.`)) return;

        const featuresToDelete = longstandingGeoJSONRef.current.features.filter(
            f => f?.feature_data_simple?.layer === layerName
        );

        // Remove empty/newly-created layer immediately.
        if (featuresToDelete.length === 0) {
            setLayerEditing(prev => {
                const updated = { ...prev };
                delete updated[layerName];
                return updated;
            });

            setOpenLayers(prev => {
                const updated = { ...prev };
                delete updated[layerName];
                return updated;
            });

            setLayers(prev => prev.filter(l => l !== layerName));

            return;
        }

        const deletePayload = featuresToDelete.map(f => ({
            skylark_id: f.skylark_id,
            _delete: true
        }));

        try {
            const token = localStorage.getItem("token");

            if (!token && !workingLocally) {
                throw new Error("No token in local storage");
            }

            const url = `${apiBaseUrl}/api/maps/${currentMapIdRef.current}/features?srid=${srid}`;

            const response = await fetch(url, {
                method: "PATCH",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(deletePayload),
            });

            if (!response.ok) {
                throw new Error(`API error: ${response.statusText}`);
            }

            toastRef.current(`Layer "${layerName}" deleted`, "success");

            const idsToDelete = new Set(deletePayload.map(f => f.skylark_id));

            longstandingGeoJSONRef.current.features =
                longstandingGeoJSONRef.current.features.filter(
                    f => !idsToDelete.has(f.skylark_id)
                );

            setFeatureVisibility(prev => {
                const updated = { ...prev };
                idsToDelete.forEach(id => delete updated[id]);
                return updated;
            });

            [fmesh, fmeshPoints].forEach(mesh => {
                mesh.children
                    .filter(child => idsToDelete.has(child.name))
                    .forEach(child => mesh.remove(child));
            });

            setLayerEditing(prev => {
                const updated = { ...prev };
                delete updated[layerName];
                return updated;
            });

            setOpenLayers(prev => {
                const updated = { ...prev };
                delete updated[layerName];
                return updated;
            });

            setLayers(prev => prev.filter(l => l !== layerName));

            polygonCustomLayerRef.current.map_repaint();

        } catch (err) {
            console.error("Error deleting layer:", err);
            toastRef.current("Failed to delete layer", "error");
        }
    };

    const isEditable = (feature) => {
        if (!feature.feature_data_simple) return true;
        return !Object.keys(feature.feature_data_simple).some(key => key.includes("_rlm_"));
    };

    // drawing a new feature to the selected layer will add it to the longstandinggeojsonref

    const handleAddFeatureToLayer = (layerName) => {
        if (!mapRef.current) return;
        if (!mapRef.current._controls?.includes(drawRef.current)) {
            mapRef.current.addControl(drawRef.current);
        }
        pendingFeatureRef.current = { layerName };
        drawRef.current.changeMode("draw_polygon");
    };
    useEffect(() => {
        if (!mapRef.current) return;
        const handleCreate = (e) => {
            const drawnFeature = e.features?.[0];
            if (!drawnFeature) return;
            const template = longstandingGeoJSONRef.current.features?.[1];
            if (!template) {
                console.warn("Template feature missing");
                return;
            }
            const layerName = pendingFeatureRef.current?.layerName || "Base Map Layer";
            const newFeature = {
                type: "Feature",
                external_ids: {
                    searchlight_property_id: uuidv4(),
                    OBJECTID: uuidv4(),
                    OID_: uuidv4(),
                    id: uuidv4(),
                },
                feature_data_simple: {
                    ...JSON.parse(JSON.stringify(template.feature_data_simple || {})),
                    layer: layerName,
                },
                feature_data_simple_timeseries: JSON.parse(JSON.stringify(template.feature_data_simple_timeseries || {})),
                feature_data_standard: {
                    ...JSON.parse(JSON.stringify(template.feature_data_standard || {})),
                    created: selectedYearEditing,
                },
                feature_data_standard_calculated: {
                    Shape_Area: turf.area(drawnFeature.geometry),
                    Shape_Length: turf.length(drawnFeature.geometry),
                },
                geometry: drawnFeature.geometry,
                skylark_id: uuidv4(),
                successor_skylark_id: uuidv4(),
            };
            longstandingGeoJSONRef.current = {
                ...longstandingGeoJSONRef.current,
                features: [
                    ...longstandingGeoJSONRef.current.features,
                    newFeature,
                ],
            };
            setFeatureVisibility(prev => ({
                ...prev,
                [newFeature.skylark_id]: true,
            }));
            drawRef.current.deleteAll();
            setEditingState(prev => ({ ...prev }));
            setFeatureAdded(newFeature);
            pendingFeatureRef.current = null;
        };
        mapRef.current.on("draw.create", handleCreate);
        return () => mapRef.current.off("draw.create", handleCreate);
    }, []);

    // reset map when a new feature has been drawn to a layer

    useEffect(() => {
        if (!featureAdded) return;
        requestAnimationFrame(() => {
            setTimeout(() => {
                ResetMap(globalRefs, globalState);
                mapRef.current.removeControl(drawRef.current);
            }, 10);
        });
    }, [featureAdded]);

    // delete feature and patch to the API

    const handleDeleteFeature = async (featureToDelete, index, e) => {
        e.stopPropagation();
        if (!window.confirm("Delete this feature?")) return;
        const skylark_id = featureToDelete.skylark_id;
        const deletePayload = [{ skylark_id, _delete: true }];
        try {
            const token = localStorage.getItem("token");
            if (!token) throw new Error("No token in local storage");

            const response = await fetch(
                `${apiBaseUrl}/api/maps/${currentMapIdRef.current}/features?srid=${srid}`,
                {
                    method: "PATCH",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(deletePayload),
                }
            );

            if (!response.ok) {
                toastRef.current("Failed to delete feature", "error");
                throw new Error(`API error: ${response.statusText}`);
            }

            toastRef.current("Feature deleted", "success");
        } catch (err) {
            console.error("Error deleting feature:", err);
        }
        longstandingGeoJSONRef.current.features = longstandingGeoJSONRef.current.features.filter(f => f.skylark_id !== skylark_id);
        setFeatureVisibility(prev => {
            const updated = { ...prev };
            delete updated[skylark_id];
            return updated;
        });
        fmesh.children = fmesh.children.filter(child => child.name !== skylark_id);
        fmeshPoints.children = fmeshPoints.children.filter(child => child.name !== skylark_id);
        setEditingState(prev => {
            const updated = { ...prev };
            delete updated[index];
            return updated;
        });
        setEditingState(prev => ({ ...prev }));
        polygonCustomLayerRef.current.map_repaint();
    };

    // clicking a feature adds it to MultuGroupSelectedArray

    const addFeatureToSelectedLayerArray = (skylark_id) => {
        setMultuGroupSelectedArray(prev => {
            if (prev.includes(skylark_id)) {
                return prev.filter(id => id !== skylark_id);
            }
            return [...prev, skylark_id];
        });
        setIsRighdivrawerVisible(true);
        setActiveTab("GROUP");
        setIsRealmLeftClickedInfoVisible(true);
        const feature = longstandingGeoJSONRef.current.features.find(
            f => f.skylark_id === skylark_id
        );
        if (feature?.geometry && mapRef.current) {
            const geojsonFeature = turf.feature(
                feature.geometry,
                { skylark_id: feature.skylark_id }
            );
            const bbox = turf.bbox(geojsonFeature); // [minX, minY, maxX, maxY]
            const currentPitch = mapRef.current.getPitch();
            const currentBearing = mapRef.current.getBearing();
            mapRef.current.fitBounds(
                [
                    [bbox[0], bbox[1]], // southwest
                    [bbox[2], bbox[3]]  // northeast
                ],
                {
                    padding: 200,
                    duration: 1000,
                    maxZoom: 20,
                    pitch: currentPitch,
                    bearing: currentBearing
                }
            );
        }
    };

    useEffect(() => {
        if (!multuGroupSelectedArray.length) return;
        const latestSelectedId =
            multuGroupSelectedArray[multuGroupSelectedArray.length - 1];
        const el = selectedFeatureRefs.current[latestSelectedId];
        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
            });
        }
    }, [multuGroupSelectedArray]);

    return (
        <div className="layersPanel" style={{ width: '80%', marginLeft: '10%' }}>
            {Object.entries(groupedLayers).map(([layerName, layerFeatures]) => {
                const isOpen = openLayers[layerName];

                return (
                    <div
                        key={layerName}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={async (e) => {
                            e.preventDefault();
                            const draggedIndex = e.dataTransfer.getData("featureIndex");
                            if (draggedIndex !== undefined) {
                                features[draggedIndex].feature_data_simple.layer = layerName;
                                setEditingState(prev => ({ ...prev }));
                                const feature = features[draggedIndex];
                                const changedFeature = {
                                    skylark_id: feature.skylark_id,
                                    feature_data_simple: features[draggedIndex].feature_data_simple,
                                };
                                console.log(changedFeature)
                                try {
                                    const token = localStorage.getItem("token");
                                    if (!token) throw new Error("No token in local storage");

                                    const response = await fetch(
                                        `${apiBaseUrl}/api/maps/${currentMapIdRef.current}/features?srid=${srid}`,
                                        {
                                            method: "PATCH",
                                            headers: {
                                                "Authorization": `Bearer ${token}`,
                                                "Content-Type": "application/json",
                                            },
                                            body: JSON.stringify([changedFeature]),
                                        }
                                    );

                                    if (!response.ok) {
                                        toastRef.current("Failed to update feature on server", "error");
                                        throw new Error(`API error: ${response.statusText}`);
                                    } else {
                                        toastRef.current("Feature updated successfully", "success");
                                    }

                                    console.log("response from API on drop:", response);
                                    console.log("successfully patched feature:", changedFeature);

                                    setRecentChangeList([]);
                                    setAPIReportMessage("");
                                } catch (err) {
                                    console.error("Error patching feature:", err);
                                }
                            }
                        }}
                    >

                        <div key={layerName} style={{ marginBottom: "10px" }}>
                            <div
                                className="layerToggleButton"
                                onClick={() => toggleLayer(layerName)}
                                style={{
                                    width: "100%",
                                    padding: "5px",
                                    textAlign: 'left',
                                    background: "rgba(41, 100, 93, 0.1)",
                                    border: "1px solid rgb(41, 100, 93)",
                                    fontSize: '10px',
                                    borderRadius: "3px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between"
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <span style={{ fontSize: '10px' }}>
                                        {isOpen ? <IoIosArrowDown /> : <IoIosArrowForward />}
                                    </span>

                                    {layerEditing[layerName]?.isEditing ? (
                                        <input
                                            value={layerEditing[layerName].editValue}
                                            autoFocus
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={(e) => handleLayerNameChange(layerName, e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') handleLayerEditSave(layerName);
                                                if (e.key === 'Escape') handleLayerEditCancel(layerName);
                                            }}
                                            style={{
                                                fontSize: '10px',
                                                padding: '2px',
                                                border: 'none',
                                                outline: 'none',
                                                background: 'transparent'
                                            }}
                                        />
                                    ) : (
                                        <span>{layerName}</span>
                                    )}
                                </div>

                                <div style={{ display: "flex", gap: "5px" }}>
                                    {layerEditing[layerName]?.isEditing ? (
                                        <>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleLayerEditSave(layerName);
                                                }}
                                            >
                                                <TiTick />
                                            </button>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleLayerEditCancel(layerName);
                                                }}
                                            >
                                                <ImCross />
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                onClick={(e) => handleLayerEditToggle(layerName, e)}
                                                disabled={!userIsMapOwner}
                                                style={{
                                                    opacity: userIsMapOwner ? 1 : 0.4,
                                                    cursor: userIsMapOwner ? "pointer" : "not-allowed",
                                                }}
                                            >
                                                <FaPencil />
                                            </button>
                                            <button
                                                style={{
                                                    fontSize: '15px',
                                                    opacity: userIsMapOwner ? 1 : 0.4,
                                                    cursor: userIsMapOwner ? 'pointer' : 'not-allowed',
                                                }}
                                                disabled={!userIsMapOwner}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDeleteLayer(layerName);
                                                }}
                                            >
                                                <MdDeleteOutline />
                                            </button>
                                            <div style={{ marginLeft: '0px', marginTop: '3px' }}>
                                                <button
                                                    style={{ fontSize: '12px', padding: '0px 0px', cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleLayerVisibility(layerFeatures);
                                                    }}
                                                >
                                                    {/* {allVisible ? <FaRegEye /> : <FaRegEyeSlash />} */}
                                                    {isLayerFullyVisible(layerFeatures) ? <FaRegEye /> : <FaRegEyeSlash />}
                                                </button>
                                            </div>

                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Feature List */}
                            {isOpen && (

                                <div>

                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleAddFeatureToLayer(layerName);
                                        }}
                                        disabled={!userIsMapOwner}
                                        style={{
                                            fontSize: '9px',
                                            padding: '3px 6px',
                                            marginBottom: '5px',
                                            marginTop: '5px',
                                            borderRadius: '3px',
                                            border: '1px solid #29845D',
                                            background: 'rgba(41, 132, 93, 0.1)',
                                            opacity: userIsMapOwner ? 1 : 0.4,
                                            cursor: userIsMapOwner ? 'pointer' : 'not-allowed'
                                        }}
                                    >
                                        + Add Feature
                                    </button>

                                    <div
                                        ref={(el) => {
                                            if (el) featureListRefs.current[layerName] = el;
                                        }}
                                        className="featureList"
                                        style={{
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            fontSize: '10px',
                                            marginTop: '5px',
                                            paddingRight: '10px'
                                        }}
                                    >
                                        {[...layerFeatures]
                                            .sort(({ feature: a }, { feature: b }) =>
                                                (a.feature_data_simple?.shortname || a.skylark_id || "Unnamed")
                                                    .localeCompare(
                                                        b.feature_data_simple?.shortname || b.skylark_id || "Unnamed",
                                                        undefined,
                                                        {
                                                            numeric: true,
                                                            sensitivity: "base"
                                                        }
                                                    )
                                            )
                                            .map(({ feature, index }) => {
                                                if (!feature.feature_data_simple) feature.feature_data_simple = {};
                                                if (!feature.feature_data_simple.shortname) {
                                                    feature.feature_data_simple.shortname = feature.skylark_id || "Unnamed";
                                                }

                                                const { isEditing, editValue } = editingState[index] || { isEditing: false, editValue: feature.feature_data_simple.shortname };
                                                const isVisible = featureVisibility[feature.skylark_id];
                                                const geometryType = feature?.geometry?.type;
                                                const featureColor = getFeatureColor(feature.skylark_id);
                                                const editable = isEditable(feature);

                                                return (
                                                    <div
                                                        key={index}
                                                        ref={(el) => {
                                                            if (el) {
                                                                selectedFeatureRefs.current[feature.skylark_id] = el;
                                                            }
                                                        }}
                                                        className={`featureItem ${activeLayer === index + 1 ? "active" : ""}`}
                                                        draggable={editable}
                                                        onDragStart={(e) => e.dataTransfer.setData("featureIndex", index)}
                                                        onDragOver={(e) => e.preventDefault()}
                                                        onDrop={(e) => {
                                                            const draggedIndex = e.dataTransfer.getData("featureIndex");
                                                            const targetLayerName = layerName;
                                                            if (draggedIndex !== undefined) {
                                                                features[draggedIndex].feature_data_simple.layer = targetLayerName;
                                                                setEditingState(prev => ({ ...prev }));
                                                            }
                                                        }}
                                                        onClick={() => {
                                                            addFeatureToSelectedLayerArray(feature.skylark_id);
                                                        }}
                                                        className="layerFeatureButton"
                                                        style={{
                                                            padding: "3px",
                                                            borderRadius: '3px',
                                                            cursor: "pointer",
                                                            fontSize: '10px',
                                                            marginBottom: '5px',
                                                            textAlign: 'left',
                                                            position: 'relative',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '5px',
                                                            border: '1px solid #bbb',
                                                            backgroundColor: multuGroupSelectedArray.includes(feature.skylark_id) ? "#d2fcea" : "white" // highlight color
                                                        }}
                                                    >
                                                        <span style={{
                                                            fontSize: '10px',
                                                            opacity: 0.9,
                                                            color: featureColor,
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}>
                                                            {getGeometryIcon(geometryType)}
                                                        </span>

                                                        {isEditing ? (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flexGrow: 1 }}>
                                                                <input
                                                                    type="text"
                                                                    value={editValue}
                                                                    autoFocus
                                                                    onChange={(e) => handleChange(index, e)}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') handleSaveEdit(index, feature);
                                                                        if (e.key === 'Escape') handleCancelEdit(index, feature);
                                                                    }}
                                                                    style={{
                                                                        flexGrow: 1,
                                                                        fontSize: '10px',
                                                                        padding: '2px',
                                                                        border: 'none',
                                                                        outline: 'none',
                                                                        textAlign: 'left',
                                                                        maxWidth: '145px'
                                                                    }}
                                                                />
                                                                <button
                                                                    style={{ textAlign: 'left', color: 'black', borderRadius: '3px', fontSize: '12px' }}
                                                                    onClick={() => handleSaveEdit(index, feature)}
                                                                >
                                                                    <TiTick />
                                                                </button>
                                                                <button
                                                                    style={{ textAlign: 'left', color: 'black', borderRadius: '3px', fontSize: '8px' }}
                                                                    onClick={() => handleCancelEdit(index, feature)}
                                                                >
                                                                    <ImCross />
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <span style={{ flexGrow: 1, textAlign: 'left' }}>
                                                                    {editValue.length > 27 ? editValue.slice(0, 27) + "..." : editValue}
                                                                </span>

                                                                {editable && (
                                                                    <>
                                                                        <button
                                                                            style={{
                                                                                top: '4px',
                                                                                fontSize: '8px',
                                                                                right: '20px',
                                                                                position: 'absolute',
                                                                                opacity: userIsMapOwner ? 1 : 0.4,
                                                                                cursor: userIsMapOwner ? 'pointer' : 'not-allowed',
                                                                            }}
                                                                            disabled={!userIsMapOwner}
                                                                            onClick={(e) => handleToggleEdit(index, e)}
                                                                        >
                                                                            <FaPencil />
                                                                        </button>

                                                                        <button
                                                                            style={{
                                                                                top: '2px',
                                                                                fontSize: '12px',
                                                                                right: '3px',
                                                                                position: 'absolute',
                                                                                opacity: userIsMapOwner ? 1 : 0.4,
                                                                                cursor: userIsMapOwner ? 'pointer' : 'not-allowed',
                                                                            }}
                                                                            disabled={!userIsMapOwner}
                                                                            onClick={(e) => handleDeleteFeature(feature, index, e)}
                                                                        >
                                                                            <MdDeleteOutline />
                                                                        </button>
                                                                    </>
                                                                )}

                                                                {!editable && (
                                                                    <span
                                                                        style={{
                                                                            top: '4px',
                                                                            fontSize: '7px',
                                                                            right: '5px',
                                                                            position: 'absolute',
                                                                            color: '#555',
                                                                            fontStyle: 'italic',
                                                                        }}
                                                                    >
                                                                        API
                                                                    </span>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}

            <div className="" style={{ marginTop: "10px" }}>
                {showNewLayerInput ? (
                    <>
                        <b style={{ fontSize: '10px' }}>Adding new Layer</b><br />
                        <input
                            type="text"
                            placeholder="New Layer Name"
                            value={newLayerName}
                            onChange={(e) => setNewLayerName(e.target.value)}
                            style={{
                                fontSize: '10px',
                                padding: '2px',
                                borderRadius: '3px',
                                border: '1px solid #29845D',
                                marginRight: '5px',
                            }}
                        />
                        <button
                            onClick={handleConfirmNewLayer}
                            style={{
                                fontSize: '9px',
                                padding: '3px 6px',
                                marginBottom: '5px',
                                marginTop: '5px',
                                borderRadius: '3px',
                                border: '1px solid #29845D',
                                background: 'rgba(41, 132, 93, 0.1)',
                                cursor: 'pointer'
                            }}
                        >
                            Confirm
                        </button>
                        <button
                            onClick={handleCancelNewLayer}
                            style={{
                                fontSize: '9px',
                                marginLeft: '5px',
                                right: '0px',
                                padding: '3px 6px',
                                marginBottom: '5px',
                                marginTop: '5px',
                                borderRadius: '3px',
                                border: '1px solid #29845D',
                                background: 'rgba(41, 132, 93, 0.1)',
                                cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>
                    </>
                ) : (
                    <button
                        onClick={handleAddLayerClick}
                        disabled={!userIsMapOwner}
                        style={{
                            fontSize: '9px',
                            padding: '3px 6px',
                            marginBottom: '5px',
                            marginTop: '5px',
                            borderRadius: '3px',
                            border: '1px solid #29845D',
                            background: 'rgba(41, 132, 93, 0.1)',
                            opacity: userIsMapOwner ? 1 : 0.4,
                            cursor: userIsMapOwner ? 'pointer' : 'not-allowed'
                        }}
                    >
                        {!showAddLayerModel ? (
                            <>+ Add New Layer</>
                        ) : (
                            <>- Cancel Add New Layer</>
                        )}
                    </button>
                )}

                {showAddLayerModel && (
                    <div style={{ display: 'block', backgroundColor: 'transparent' }}>
                        <button
                            onClick={handleAddBlankLayerClick}
                            style={{
                                display: 'block',
                                padding: '5px',
                                borderRadius: '3px',
                                border: '1px solid rgb(41, 100, 93)',
                                backgroundColor: 'rgba(41, 100, 93, 0.1)',
                                width: '90%',
                                marginLeft: '5%',
                                marginTop: '5px',
                                fontSize: '10px'
                            }}
                        >Add Blank Layer</button>
                        <button
                            // INACTIVE FOR NOW
                            disabled
                            style={{
                                display: 'block',
                                padding: '5px',
                                borderRadius: '3px',
                                border: '1px solid #bdbdbd',
                                backgroundColor: '#f5f5f5',
                                color: '#9e9e9e',
                                width: '90%',
                                marginLeft: '5%',
                                marginTop: '5px',
                                fontSize: '10px',
                                opacity: 0.6,
                                cursor: 'not-allowed'
                            }}
                        >
                            Add API Layer
                        </button>
                        <button
                            // INACTIVE FOR NOW
                            disabled
                            style={{
                                display: 'block',
                                padding: '5px',
                                borderRadius: '3px',
                                border: '1px solid #bdbdbd',
                                backgroundColor: '#f5f5f5',
                                color: '#9e9e9e',
                                width: '90%',
                                marginLeft: '5%',
                                marginTop: '5px',
                                fontSize: '10px',
                                opacity: 0.6,
                                cursor: 'not-allowed'
                            }}
                        >
                            Upload Data as Layer
                        </button>

                    </div>
                )}

            </div>
        </div >
    );
};

export default LayersPanel;
